@if (isNative) {
  <homey-native-landing-page/>
} @else {
  <section class="pb-4">
    <h1 class="sr-only">Homey NYC Housing Lottery Made Easy</h1>
    <p class="text-[2.85rem] mb-4 mt-4 leading-[3.25rem] text-center font-medium">
      <span class="inline-block">Housing Lottery</span>
      <br>
      <span class="inline-block"><span class="text-orange-gradient">Made Easy</span></span>
    </p>
    <div class="bg-surface-100 rounded-xl px-6 pt-6 mt-12">
      <h2 class="text-center text-2xl font-medium">
        <p class="m-0">Auto-apply for every</p>
        <p class="m-0">NYC Housing Lottery</p>
        <p class="m-0">in 7 minutes</p>
      </h2>

      <div class="flex flex-row justify-center mt-6 pb-4">
        <homey-signup-button signupText="Try for $0" severity="secondary"/>
      </div>

      <img src="/assets/landing-page/new-landing-page-image-B.webp" class="px-4 pt-6"
           alt="Homey NYC in action"/>
    </div>
  </section>

  <div class="mt-12">
    <h2 class="text-center font-medium text-lg mb-8">Featured in</h2>
    <div class="flex flex-row gap-4 justify-around items-center">
      <a href="https://secretnyc.co/homey-affordable-housing-app/" target="_blank" rel="noopener">
        <img src="/assets/landing-page/articles/secret-nyc.png"
             alt="Featured on: Secret NYC, This Brand-New App Will Apply To Affordable Housing Lotteries For You, And It's A Lifesaver."
             class="max-h-12"/>
      </a>
      <a
        href="https://www.timeout.com/newyork/news/this-useful-new-app-automatically-applies-for-affordable-housing-units-that-you-qualify-for-050125"
        target="_blank" rel="noopener">
        <img src="/assets/landing-page/articles/timeout-nyc.png"
             alt="Featured on: Timeout NYC, This useful new app automatically applies for affordable housing units that you qualify for."
             class="max-h-16"/>
      </a>
      <a
        href="https://pix11.com/news/local-news/new-homey-app-helps-simplify-affordable-housing-lottery-application/">
        <img src="/assets/landing-page/articles/pix11.webp"
             alt="Featured on: Pix11, New Homey app helps simplify affordable housing lottery application"
             class="max-h-14"/>
      </a>
    </div>
  </div>

  <section class="bleed-bg bleed-surface-100 pt-12 pb-12 mt-14">
    <h2 class="text-center text-4xl font-medium mb-8 mt-2">
      Find out which places you qualify for
    </h2>
    <homey-housing-opportunities-search class="block mb-12" id="eligibility" [route]="['apartments-search']"
                                        [replace]="true"/>
    <div class="flex flex-row justify-center mt-20">
      <homey-signup-button signupText="Apply now"/>
    </div>
  </section>

  <section class="pt-16 mb-12">
    <h2 class="text-center text-4xl font-medium mb-8">Our users</h2>
    <homey-review-carousel [articleLinksEnabled]="true"/>
    <div class="flex flex-row mt-12 justify-center">
      <homey-signup-button signupText="Check your eligibility"/>
    </div>
  </section>

  <div class="flex flex-col">
    <div class="mt-16">
      <section class="bleed-bg bleed-blue-500 mb-24 mt-24 section bg-blue-500 text-white">
        <div class="top-curve bg-blue-500 h-40"></div>
        <div class="bottom-curve bg-blue-500 h-40"></div>
        <h2 class="text-4xl text-center font-medium mb-14">How it works</h2>
        <div class="flex flex-col gap-12">
          <div class="flex flex-row gap-4">
            <i class="pi pi-stopwatch" style="font-size: 2rem"></i>
            <div>
              <p class="text-xl font-medium mt-1 mb-1">Create a profile in minutes</p>
              <p>We take the work out of paperwork, so you don't have to worry about it.</p>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <i class="pi pi-folder-open" style="font-size: 2rem"></i>
            <div>
              <p class="text-xl font-medium mt-1 mb-1">We apply for you, continuously</p>
              <p>We will keep applying you for all new housing opportunities, until you win.</p>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <i class="pi pi-bell" style="font-size: 2rem"></i>
            <div>
              <p class="text-xl font-medium mt-1 mb-1">Get notified when you win</p>
              <p>No need to check in, we notify you when you're selected!</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <section class="pt-16 pb-8 section">
    <h2 class="text-center text-4xl font-medium mb-10">Your next home <br> could be</h2>
    <ul class="flex flex-col gap-6 h-[30rem]">
      <li class="flex-1">
        <homey-next-home-card
          class="h-full"
          title="Brand new."
          description="All apartments in the NYC Housing Lottery are brand-new. Say goodbye to old and badly maintained buildings."/>
      </li>
      <li class="flex-1">
        <homey-next-home-card
          class="h-full"
          title="Rent-stabilized."
          description="All the apartments are rent-stabilized, so rent increases over the years are limited."/>
      </li>
      <li class="flex-1">
        <homey-next-home-card
          class="h-full"
          title="Yours forever."
          description="You can stay in your apartment as long as you want. People stay for 12 years on average."/>
      </li>
    </ul>
  </section>

  <section class="pt-16 pb-8 section">
    <h2 class="text-center text-4xl font-medium mb-10">Homey makes the <br>Housing Lottery easy</h2>
    <ul class="flex flex-col gap-14 mb-10">
      <li>
        <homey-why-card
          image="/assets/landing-page/why/why-1.webp"
          title="Create a profile in only 7 min"
          description="When going through Housing Connect, you can spend a lot of time just creating your profile. We cut it down to the essentials."
        />
      </li>
      <li>
        <homey-why-card
          image="/assets/landing-page/why/why-2.webp"
          title="Homey applies for you"
          description="With Homey, you don't have to go looking through lotteries and apply for each individual one. Homey matches you with the lotteries you're eligible for, and files your applications for you."
        />
      </li>
      <li>
        <homey-why-card
          image="/assets/landing-page/why/why-3.webp"
          title="Get notified when you win"
          description="You don't have to set up reminders to check in on your applications, Homey will contact you when you win, and guide you through the remaining paperwork."
        />
      </li>
    </ul>
    <div class="flex flex-row mb-8 justify-center">
      <homey-signup-button/>
    </div>
  </section>

  <section class="bleed-bg bleed-orange-500 mb-24 mt-24 section bg-blue-500">
    <div class="top-curve bg-orange-500 h-40"></div>
    <div class="bottom-curve bg-orange-500 h-40"></div>
    <h2 class="text-4xl text-center font-medium mb-14">How we protect your data</h2>
    <div class="flex flex-col gap-12">
      <div class="flex flex-row gap-4">
        <i class="pi pi-address-book" style="font-size: 2rem"></i>
        <div>
          <p class="text-xl font-medium mt-1 mb-1">We only ask the essentials</p>
          <p>We only ask for the basic details needed to submit your applications, no SSN or official documents.</p>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <i class="pi pi-link" style="font-size: 2rem"></i>
        <div>
          <p class="text-xl font-medium mt-1 mb-1">We only share with NYC HPD</p>
          <p>Your info is shared only with NYC Housing Preservation and Development to file applications, never with
            anyone else.</p>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <i class="pi pi-shield" style="font-size: 2rem"></i>
        <div>
          <p class="text-xl font-medium mt-1 mb-1">We encrypt all your data</p>
          <p>We use bank-level encryption (AES-256) and secure servers to protect your data.</p>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-center mt-10">
      <a pButton severity="secondary" [dt]="yourDataButton" [routerLink]="['your-data']" label="Learn more about your data"></a>
    </div>
  </section>

  <section class="py-16">
    <h2 class="text-4xl font-medium mb-4 text-center">Common questions</h2>
    <p-accordion>
      @for (faq of faqs; let i = $index; track faq.answer) {
        <p-accordion-panel value="{{ i }}">
          <p-accordion-header>
            <span>
              {{ faq.question }}
            </span>
          </p-accordion-header>
          <p-accordion-content>
            <p class="m-0" [innerHTML]="faq.answer"></p>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </section>

  <homey-full-footer [showLogin]="true"/>
}
